import { provide as e, inject as t } from "vue";
let o = Symbol("Context");
var i = ((n) => (n[n.Open = 1] = "Open", n[n.Closed = 2] = "Closed", n[n.Closing = 4] = "Closing", n[n.Opening = 8] = "Opening", n))(i || {});
function s() {
  return t(o, null);
}
function p(n) {
  e(o, n);
}
export {
  i as State,
  s as useOpenClosed,
  p as useOpenClosedProvider
};
